const isAndroid = () => typeof window !== 'undefined' && window.navigator && window.navigator.platform && /Android/.test(window.navigator.platform);

export default isAndroid;
